module.exports = __webpack_public_path__ + "img/Owner_Warehouse.c9cd3e25.jpg";